import * as React from 'react';
import styled from '@emotion/styled';
import { keyframes } from '@emotion/react';

export const TASK_CYCLE_DURATION = '2s';
export const TASK_BURST_EASE = 'cubic-bezier(0.2, 0.8, 0.3, 1)';

interface TaskConnectionWidgetProps {
  d: string;
  color?: string;
  active?: boolean;
  running?: boolean;
}

export const TaskConnectionWidget: React.FC<TaskConnectionWidgetProps> = ({
  d,
  color = 'currentColor',
  active = true,
  running = true
}) => (
  <S.Path d={d} stroke={color} fill="none" strokeWidth="2" strokeDasharray="5 22" $active={active} $running={running} />
);

namespace S {
  const travel = keyframes`
    0%, 25% { stroke-dashoffset: 0; }
    70%, 100% { stroke-dashoffset: -54; }
  `;

  export const Path = styled.path<{ $active: boolean; $running: boolean }>`
    animation: ${travel} ${TASK_CYCLE_DURATION} ${TASK_BURST_EASE} infinite;
    animation-name: ${(p) => (p.$active ? travel : 'none')};
    animation-play-state: ${(p) => (p.$running ? 'running' : 'paused')};
    @media (prefers-reduced-motion: reduce) {
      animation: none;
    }
  `;
}
